import { TranslateService } from '@ngx-translate/core';
import { mapStringsDeep } from './map-strings-deep';

/**
 * `translate.instant()` for a nested object/array of texts (e.g. the sections of a legal page): ngx-translate only fills
 * `{{params}}` in plain strings, so the placeholders inside the returned structure are filled here.
 * Routed pages are created once the translations are loaded and re-created on language change, so they can call it
 * while they initialize.
 * @param translate - The TranslateService
 * @param key - Translation key pointing to an object or an array
 * @param params - Values for the `{{placeholders}}` used in the texts (e.g. `{ appName: 'Wissal Univers' }`)
 */
export function translatedContent<T>(
  translate: TranslateService,
  key: string,
  params: Record<string, string> = {},
): T {
  return mapStringsDeep(translate.instant(key), (text) => translate.parser.interpolate(text, params) ?? text) as T;
}

/** translatedContent() for a key holding an array; returns `[]` when the key is missing. */
export function translatedList<T>(
  translate: TranslateService,
  key: string,
  params: Record<string, string> = {},
): T[] {
  const content = translatedContent<unknown>(translate, key, params);
  return Array.isArray(content) ? (content as T[]) : [];
}
